import {css} from 'aphrodite';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import getProcedureReplicateName from 'procedures/utils/getProcedureReplicateNames';
import getProcedureRunConditionName from 'procedures/utils/getProcedureRunConditionNames';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import {ChipSize} from 'ui-library/chips/Chip';
import ProcessTaskChip from 'ui-library/chips/ProcessTaskChip';

import FormattedTextField from '../fields/FormattedTextField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {getProceduresUnitOperationTaskDetailsSummaryRows} from '../procedures/getProceduresUnitOperationTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  getProcessTaskDetailsLabels,
  ProcessTaskGql,
} from '../ProcessTaskDetailsPageConstants';

export function getAssayUnitOperationTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  const methodExecutionInstance = processTask.procedureMethodExecutionInstance;
  let conditionsDisplayString = null;
  let procedureRun = null;
  let replicateDisplayString = null;
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    procedureRun = methodExecutionInstance.procedureRun;
    conditionsDisplayString = getProcedureRunConditionName(methodExecutionInstance);
    replicateDisplayString = getProcedureReplicateName(methodExecutionInstance);
  }
  const processTaskDetailsLabels = getProcessTaskDetailsLabels();

  return getProceduresUnitOperationTaskDetailsSummaryRows(processTask, onUpdateTask, {
    experimentRunContent: {
      label: processTaskDetailsLabels.ASSAY_CONDITION_REPLICATE_RUN,
      component:
        processTask.rootTasks.length > 0 ? (
          <>
            {processTask.rootTasks.map((rootTask) => (
              <ProcessTaskChip
                key={rootTask.id}
                id={rootTask.id}
                className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
                size={ChipSize.TABLE_CELL}
              />
            ))}
          </>
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    procedureTemplateContent: {
      label: processTaskDetailsLabels.ASSAY_TEMPLATE,
      component:
        procedureRun != null ? (
          <ProcedurePageLinkForProcedureRun
            procedureRun={procedureRun}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    conditionsContent: {
      label: processTaskDetailsLabels.ASSAY_CONDITIONS,
      component: conditionsDisplayString ? (
        <FormattedTextField text={conditionsDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    replicatesContent: {
      label: processTaskDetailsLabels.ASSAY_REPLICATE,
      component: replicateDisplayString ? (
        <FormattedTextField text={replicateDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
  });
}
